import { LMBaseComponent } from './lm-base.component';
import { SohoModalDialogService } from 'ids-enterprise-ng';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { LMComponentInfoService, LMLoggerService } from '@services/index';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';
import { Directive } from '@angular/core';
import { LMAppComponentService } from '@utils/lm-app-component.service';

@Directive()
export abstract class LMBaseFormComponent extends LMBaseComponent {

  protected instanceId: string;

  constructor(
    public sohoModalDialogService: SohoModalDialogService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected lmLoggerService: LMLoggerService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected lmAppComponentService: LMAppComponentService,
  ) {
    super(sohoModalDialogService, lmBusyIndicatorService, lmComponentInfoService, lmUniqueIdService, lmAppComponentService);
    this.instanceId = this.lmLoggerService.instanceId;
  }

  public abstract load(fromDataView?: LMDataView): Promise<LoadResponse<LMDataView | LMDataViewSet>>;
  public abstract isRouteReuseActive(): boolean;
  public abstract setRouteReuseActive(active: boolean, keys?: string): void;
  public abstract getSpec(): LMListSpec | LMFormSpec | LMPageSpec;
}

export interface LoadResponse<t> {
  data?: t;
}
